
import axios from "axios"

export async function getPriceApi(data) {
    try {
        let response = await axios.get('https://min-api.cryptocompare.com/data/price?',
            {
                headers: { authorization: `Apikey e282cc17a57d94dd4241872674797c4c83cb376c4db196521fc105f9e849578c` },
                params: data
            },);
        return response;
    } catch (error) {
        return error
    }
}

export async function verifyWalletApi(data) {

    try {
        let response = await axios.get('https://api.transak.com/api/v2/currencies/verify-wallet-address?', { params: data });
        return response;
    } catch (error) {
        return error
    }
}



export async function getAccesTokenInfo(data) {

    try {
        let response = await axios.get('https://www.googleapis.com/oauth2/v3/userinfo?access_token=' + data);
        return response;
    } catch (error) {
        return error
    }
}

